// import React from "react";
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
//   Navigate,
//   useLocation,
// } from "react-router-dom";
// import { AuthProvider } from "./contexts/AuthContext";
// import ProtectedRoute from "./components/ProtectedRoute";
// import MainPage from "./pages/MainPage";
// import StarfieldBackground from "./components/StarfieldBackground";
// import ProfilePage from "./pages/Profilepage";
// import LandingPage from "./pages/LandingPage"; // Import the new LandingPage
// import MoonshotStep1 from "./pages/MoonshotStep1";
// import RealityCheck from "./pages/RealityCheck";
// import ClarityCheck from "./pages/ClarityCheck";
// import FogIndex from "./pages/FogIndex";
// import MiniShotDetail from "./pages/MiniShotDetail";
// import ReportsList from "./pages/ReportsList";
// import PricingPage from "./pages/PricingPage";
// import HowToUsePage from "./pages/HowToUsePage"; // Import new page
// import SecurityPage from "./pages/SecurityPage";
// import PrivacyPage from "./pages/PrivacyPage"; // Import new page
// import TermsPage from "./pages/TermsPage"; // Import new page
// import FounderGuidePage from "./pages/FounderGuidePage"; // Import new page

// import "./App.css";

// import ScrollToTop from "./components/ScrollToTop"; // Import ScrollToTop

// function App() {
//   function ConditionalStarfield() {
//     const location = useLocation();

//     if (location.pathname === "/" || location.pathname === "/login") {
//       return <StarfieldBackground />;
//     }

//     return null;
//   }

//   return (
//     <Router>
//       <ScrollToTop />
//       <AuthProvider>
//         <div className="App">
//           {/* <ConditionalStarfield /> */}
//           <Routes>
//             <Route path="/" element={<LandingPage />} />
//             <Route path="/login" element={<LandingPage />} />
//             <Route path="/pricing" element={<PricingPage />} />
//             <Route path="/how-to-use" element={<HowToUsePage />} />
//             <Route path="/security" element={<SecurityPage />} />
//             <Route path="/privacy" element={<PrivacyPage />} />
//             <Route path="/terms" element={<TermsPage />} />
//             <Route path="/founder-guide" element={<FounderGuidePage />} />
//             <Route
//               path="/mainPage"
//               element={
//                 <ProtectedRoute>
//                   <MainPage />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="/moonshot"
//               element={
//                 <ProtectedRoute>
//                   <MoonshotStep1 />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="/profile"
//               element={
//                 <ProtectedRoute>
//                   <ProfilePage />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="/realitycheck"
//               element={
//                 <ProtectedRoute>
//                   <RealityCheck />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="/claritycheck"
//               element={
//                 <ProtectedRoute>
//                   <ClarityCheck />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="/fogindex"
//               element={
//                 <ProtectedRoute>
//                   <FogIndex />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="/minishot/:id"
//               element={
//                 <ProtectedRoute>
//                   <MiniShotDetail />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="/reports"
//               element={
//                 <ProtectedRoute>
//                   <ReportsList />
//                 </ProtectedRoute>
//               }
//             />
//           </Routes>
//         </div>
//       </AuthProvider>
//     </Router>
//   );
// }

// export default App;
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import MainPage from "./pages/MainPage";
import StarfieldBackground from "./components/StarfieldBackground";
import ProfilePage from "./pages/Profilepage";
import LandingPage from "./pages/LandingPage";
import MoonshotStep1 from "./pages/MoonshotStep1";
import RealityCheck from "./pages/RealityCheck";
import ClarityCheck from "./pages/ClarityCheck";
import FogIndex from "./pages/FogIndex";
import MiniShotDetail from "./pages/MiniShotDetail";
import ReportsList from "./pages/ReportsList";
import PricingPage from "./pages/PricingPage";
import HowToUsePage from "./pages/HowToUsePage";
import SecurityPage from "./pages/SecurityPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import FounderGuidePage from "./pages/FounderGuidePage";

// --- IMPORT THE NEW DATA ROOM PAGE ---
import DataRoom from "./pages/DataRoom";
import MoonshotMapPage from "./pages/MoonshotMapPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
// -------------------------------------
// -------------------------------------

import "./App.css";

import ScrollToTop from "./components/ScrollToTop";

function App() {
  function ConditionalStarfield() {
    const location = useLocation();

    if (location.pathname === "/" || location.pathname === "/login") {
      return <StarfieldBackground />;
    }

    return null;
  }

  return (
    <Router>
      <ScrollToTop />
      <AuthProvider>
        <div className="App">
          {/* <ConditionalStarfield /> */}
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LandingPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/how-to-use" element={<HowToUsePage />} />
            <Route path="/security" element={<SecurityPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/founder-guide" element={<FounderGuidePage />} />

            <Route
              path="/mainPage"
              element={
                <ProtectedRoute>
                  <MainPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/moonshot"
              element={
                <ProtectedRoute>
                  <MoonshotStep1 />
                </ProtectedRoute>
              }
            />

            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />

            {/* --- NEW DATA ROOM ROUTE --- */}
            <Route
              path="/dataroom"
              element={
                <ProtectedRoute>
                  <DataRoom />
                </ProtectedRoute>
              }
            />

            {/* --- NEW MOONSHOT MAP ROUTE --- */}
            <Route
              path="/moonshot-map"
              element={
                <ProtectedRoute>
                  <MoonshotMapPage />
                </ProtectedRoute>
              }
            />

            {/* --- BLOG ROUTES --- */}
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            {/* ------------------- */}
            {/* --------------------------- */}

            <Route
              path="/realitycheck"
              element={
                <ProtectedRoute>
                  <RealityCheck />
                </ProtectedRoute>
              }
            />

            <Route
              path="/claritycheck"
              element={
                <ProtectedRoute>
                  <ClarityCheck />
                </ProtectedRoute>
              }
            />

            <Route
              path="/fogindex"
              element={
                <ProtectedRoute>
                  <FogIndex />
                </ProtectedRoute>
              }
            />

            <Route
              path="/minishot/:id"
              element={
                <ProtectedRoute>
                  <MiniShotDetail />
                </ProtectedRoute>
              }
            />

            <Route
              path="/reports"
              element={
                <ProtectedRoute>
                  <ReportsList />
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;